import React from "react";

const InfoFilledIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6ZM6 9C6.27614 9 6.5 8.77614 6.5 8.5V5C6.5 4.72386 6.27614 4.5 6 4.5C5.72386 4.5 5.5 4.72386 5.5 5V8.5C5.5 8.77614 5.72386 9 6 9ZM6 2.75C6.34518 2.75 6.625 3.02982 6.625 3.375C6.625 3.72018 6.34518 4 6 4C5.65482 4 5.375 3.72018 5.375 3.375C5.375 3.02982 5.65482 2.75 6 2.75Z"
        fill="#646F87"
      />
    </svg>
  );
};

export default InfoFilledIcon;
